import {
  RECEIVE_HOTEL_DATE_PRICES,
  RECEIVE_HOTEL_DATE_PRICES_EMPTY,
  RECEIVE_HOTEL_DATE_PRICES_ERROR,
} from '../../../helpers/constants/actionsConstants';

import type { HotelPriceData } from '../../../actions/types/dataTypes';
import type {
  HOTELS_DATE_PRICES_NETWORK_ERROR,
  HOTELS_DATE_PRICES_OTHER_ERROR,
} from '../../../helpers/constants/dataTypeConstants';

export const receiveHotelsDatePrices = (updates: HotelPriceData) => ({
  type: RECEIVE_HOTEL_DATE_PRICES,
  payload: updates,
});

export const receiveHotelsDatePricesEmpty = (emptyUpdates: HotelPriceData) => ({
  type: RECEIVE_HOTEL_DATE_PRICES_EMPTY,
  payload: emptyUpdates,
});

export const receiveHotelsDatePricesError = (payload: {
  error:
    | typeof HOTELS_DATE_PRICES_NETWORK_ERROR
    | typeof HOTELS_DATE_PRICES_OTHER_ERROR;
}) => ({
  type: RECEIVE_HOTEL_DATE_PRICES_ERROR,
  payload,
});
